const min = Math.min;
const max = Math.max;
const abs = Math.abs;

import Stats from "./util/stats"

export class NoOpControls
{

    getSteerDirection()
    {
        return 1;
    }

    getThrust()
    {
        return 0;
    }
}

export default class Controls
{
    constructor(elem, width, heigth)
    {
        this.elem = elem;
        this.width = width;
        this.heigth = heigth;

        elem.addEventListener("mousedown", this.onMouseDown);
        elem.addEventListener("mouseup", this.onMouseUp);
        //elem.addEventListener("mousemove", this.onMouseMove);

        window.addEventListener("keydown", this.onKeyDown);
        window.addEventListener("keyup", this.onKeyUp);

        this.target = 0;
        
        this.thrust = 0;
        this.targetDelta = 0;

        this.off = false;
    }

    onMouseDown = ev => this.thrust = ev.ctrlKey ? -1 : 1;
    onMouseUp = ev => this.thrust = 0;
    // onMouseMove = ev => {
    //     this.target = floor(min(max((ev.pageX / this.width - 0.5) * 9, -1), 1) * 100) / 100;
    // };

    onKeyDown = ev => {

        const { keyCode } = ev;

        switch(keyCode)
        {
            case 38:    // cursor up
            case 87:    // w
                this.thrust = 1;
                break;
            case 40:    // cursor down
            case 83:    // s
                this.thrust = -1;
                break;
            case 37:    // cursor left
            case 65:    // a
                if (this.targetDelta > 0)
                {
                    this.targetDelta = 0;
                }
                this.targetDelta = max(this.targetDelta - 0.1, -0.8);
                break;
            case 39:    // cursor right
            case 68:    // d
                if (this.targetDelta < 0)
                {
                    this.targetDelta = 0;
                }
                this.targetDelta = min(this.targetDelta + 0.1, 0.8);
                break;
            case 79:    // o
                this.off = !this.off;
                break;
        }
    };

    onKeyUp = ev => {

        const { keyCode } = ev;

        switch(keyCode)
        {
            case 87:    // w
            case 83:    // s
            case 38:    // cursor up
            case 40:    // cursor down
                this.thrust = 0;
                break;
            case 37:    // cursor left
            case 39:    // cursor right
            case 65:    // a
            case 68:    // d
                this.targetDelta =  0;
                break;
        }
    };

    destroy()
    {
        const { elem } = this;

        elem.removeEventListener("mousedown", this.onMouseDown);
        elem.removeEventListener("mouseup", this.onMouseUp);
        elem.removeEventListener("mousemove", this.onMouseMove);
    }

    getSteerDirection()
    {

        return this.target;
    }

    tick()
    {
        this.target = min(max(this.target + this.targetDelta, -2), 2);
        this.target = Math.round( this.target * 0.9 * 1000) / 1000;
        this.targetDelta = Math.round( this.targetDelta * 0.9 * 1000) / 1000;

        if (abs(this.target) < 0.01)
        {
            this.target = 0;
        }

        if (abs(this.targetDelta) < 0.01)
        {
            this.targetDelta = 0;
        }

        // Stats.update("t", this.target);
        // Stats.update("tD", this.targetDelta);
    }

    getThrust()
    {
        return this.thrust;
    }

    isEngineOff()
    {
        return this.off;
    }

}



// WEBPACK FOOTER //
// ./src/controls.js